






import {Vue, Component, Prop} from 'vue-property-decorator';
import Change, {InstanceId} from "@/components/history/dto/Change";
import ReferenceChangeView from "@/components/history/changeView/ReferenceChangeView.vue";
import ListChangeView from "@/components/history/changeView/ListChangeView.vue";
import ChangeView from "@/components/history/changeView/ChangeView.vue";

@Component({})
export default class ChangeFacadeView extends Vue {

	@Prop()
	private change!: Change<any>

	@Prop()
	private schema!: any

	@Prop()
	private label!: string

	@Prop({required: false})
	private action?: (change: InstanceId) => void

	get changeView(): typeof Vue {
		switch (this.change.changeType) {
			case "ReferenceChange": return ReferenceChangeView
			case "ListChange": return ListChangeView
			default: return ChangeView
		}
	}

}
